import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { SITE_ORIGIN } from "@/config/constants";
import { getPageSeo } from "@/config/seo";
import type { AppLocale } from "@/i18n/constants";
import type { BlogPost } from "@/blog/types";
import type { LegalPageContent } from "@/data/legal.types";
import { applyDocumentSeo, applyJsonLd } from "@/utils/documentSeo";

/**
 * Keeps <head> in sync on client-side navigation and language changes.
 * The prerendered HTML already carries the same tags for the first load.
 */
export function usePageSeo(path: string, legalPage?: LegalPageContent, blogPost?: BlogPost) {
  const { i18n } = useTranslation();
  const locale = (i18n.language === "en" ? "en" : "es") as AppLocale;

  useLayoutEffect(() => {
    const origin = SITE_ORIGIN || window.location.origin;
    const seo = getPageSeo(path, locale, origin, legalPage, blogPost);
    applyDocumentSeo(seo);
    applyJsonLd(seo.jsonLd ?? null);
  }, [path, locale, legalPage, blogPost]);
}
